import LoadingContainer from "../OverlaySpinner";
export default {
  apiKey: process.env.REACT_APP_GOOGLE_KEY,
  version: "weekly",
  libraries: ["places", "geometry", "drawing", "visualization"],
  LoadingContainer: LoadingContainer,
};
